import { ReactNode } from "react";
import { Box, Typography } from "@mui/material";

interface Props {
  label: string;
  /** Already-formatted value including its unit, e.g. "125.4B THB". */
  value: string;
  /** 24px glyph, tinted by `iconColor`. */
  icon: ReactNode;
  iconColor: string;
  /** Background of the 48px icon circle. */
  iconBg: string;
}

/**
 * Borrowers-overview stat card — Figma "Card_List" 7063:17602. Icon circle on
 * the left, label over value on the right. Borderless: it sits on the grey page.
 *
 * Figma gives the third card (7063:31334) an 8px label/value gap where the other
 * three use 4px; that one-off is treated as a slip and all four use 4px.
 */
const PortfolioStatCard = ({ label, value, icon, iconColor, iconBg }: Props) => (
  <Box
    flex={1}
    minWidth={0}
    display="flex"
    alignItems="center"
    gap="16px"
    p="20px"
    borderRadius="8px"
    bgcolor="var(--white)"
  >
    <Box
      p="12px"
      borderRadius="32px"
      bgcolor={iconBg}
      color={iconColor}
      display="flex"
      flexShrink={0}
      sx={{ "& svg": { fontSize: 24 } }}
    >
      {icon}
    </Box>
    <Box display="flex" flexDirection="column" gap="4px" minWidth={0}>
      <Typography
        fontSize="14px"
        fontWeight={500}
        lineHeight="24px"
        color="var(--dark)"
        noWrap
      >
        {label}
      </Typography>
      <Typography
        fontSize="18px"
        fontWeight={600}
        lineHeight="24px"
        color="var(--dark)"
        noWrap
      >
        {value}
      </Typography>
    </Box>
  </Box>
);

export default PortfolioStatCard;
